import '../assets/NcHotkey.css';
import { defineComponent, computed, openBlock, createElementBlock, normalizeClass, createElementVNode, renderSlot, Fragment, renderList, createBlock, createTextVNode, toDisplayString } from "vue";
import { N as NcKbd } from "./NcKbd.mjs";
import { _ as _export_sfc } from "./_plugin-vue_export-helper.mjs";
const NO_LABEL_WARNING = "⚠️ NcHotKey must have a label or slot content";
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "NcHotkey",
  props: {
    label: { default: () => void 0 },
    hotkey: { default: () => void 0 }
  },
  setup(__props) {
    const symbols = computed(() => {
      return __props.hotkey?.split(/\s+/).map((s) => s.trim());
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("li", {
        class: normalizeClass(_ctx.$style.hotkey)
      }, [
        createElementVNode("span", {
          role: "term",
          class: normalizeClass(_ctx.$style.hotkey__keys)
        }, [
          renderSlot(_ctx.$slots, "hotkey", {}, () => [
            (openBlock(true), createElementBlock(Fragment, null, renderList(symbols.value, (symbol, index) => {
              return openBlock(), createBlock(NcKbd, {
                key: index,
                symbol
              }, null, 8, ["symbol"]);
            }), 128))
          ])
        ], 2),
        createElementVNode("span", {
          role: "definition",
          class: normalizeClass(_ctx.$style.hotkey__label)
        }, [
          renderSlot(_ctx.$slots, "default", {}, () => [
            createTextVNode(toDisplayString(__props.label || NO_LABEL_WARNING), 1)
          ])
        ], 2)
      ], 2);
    };
  }
});
const hotkey = "_hotkey_kSlAl";
const hotkey__label = "_hotkey__label_LLPgA";
const hotkey__keys = "_hotkey__keys_EMshL";
const style0 = {
  "material-design-icon": "_material-design-icon_XAHPq",
  hotkey,
  hotkey__label,
  hotkey__keys
};
const cssModules = {
  "$style": style0
};
const NcHotkey = /* @__PURE__ */ _export_sfc(_sfc_main, [["__cssModules", cssModules]]);
export {
  NcHotkey as N
};
//# sourceMappingURL=NcHotkey.mjs.map
